import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for `/bookings/$reference/*` (mirrors `bookings.tsx`'s fix —
 * see that file's comment for the full explanation). Because
 * `bookings.$reference.print.tsx` exists alongside this file, TanStack
 * Router makes this the PARENT of the print route
 * (`BookingsReferenceRouteWithChildren` in `routeTree.business.gen.ts`), so
 * this file must render `<Outlet/>` and the detail UI moves to
 * `bookings.$reference.index.tsx` (`/bookings/$reference/`).
 */
export const Route = createFileRoute('/bookings/$reference')({
  component: BookingReferenceLayout,
});

function BookingReferenceLayout() {
  return <Outlet />;
}
